import React from 'react'
import { InternalPolicy } from './model/InternalPolicy'

type InternalPolicyContextValue = {
  internalPolicy: InternalPolicy
}

export const InternalPolicyContext =
  React.createContext<InternalPolicyContextValue | null>(null)
